import { Injectable } from '@angular/core';
import { ConfigModel } from '../../models';
import { DataProvider } from '../basic/data.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigProvider extends DataProvider<ConfigModel> {
  // Properties & Signals
  override endpoint = 'f/setup/basesettings';
}
